import styles from "./OfferButton.module.scss";
export type OfferButtonProps = {
  title: string;
  description: string;
  isReverse?: boolean;
};

export const OfferButton = ({
  title,
  description,
  isReverse,
}: OfferButtonProps) => {
  return (
    <div className={`${styles.item} ${isReverse ? styles.reverse : ""}`}>
      <div className={styles.bottomTitle}>{title}</div>
      <div className={styles.bottomDescription}>{description}</div>
    </div>
  );
};
